import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import './BKModal.css';

const BKModal = ({
  open,
  onClose,
  onOk,
  title,
  children,
  okText = 'Đồng ý',
  cancelText = 'Thoát',
  width = 600,
  confirmClose = true,
  confirmCloseMessage = 'Bạn có chắc chắn muốn đóng không? Các thay đổi chưa lưu sẽ bị mất.',
  footer,
  loading = false,
  closable = true,
  maskClosable = true,
  hasChanges = false,
  disableEscapeKey = false,
  className,
  ...restProps
}) => {
  const handleClose = () => {
    if (confirmClose && hasChanges) {
      Modal.confirm({
        title: 'Xác nhận',
        content: confirmCloseMessage,
        okText: 'Đóng',
        cancelText: 'Hủy',
        onOk: () => {
          onClose();
        },
        centered: true
      });
    } else {
      onClose();
    }
  };

  const handleOk = () => {
    if (onOk) {
      onOk();
    }
  };

  useEffect(() => {
    if (!disableEscapeKey || !open) {
      return;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, disableEscapeKey]);

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      onOk={handleOk}
      title={title}
      width={width}
      footer={footer}
      okText={okText}
      cancelText={cancelText}
      closable={closable}
      maskClosable={maskClosable}
      keyboard={!disableEscapeKey}
      confirmLoading={loading}
      centered
      className={className ? `bk-modal ${className}` : 'bk-modal'}
      {...restProps}>
      {children}
    </Modal>
  );
};

BKModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOk: PropTypes.func,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  width: PropTypes.number,
  confirmClose: PropTypes.bool,
  confirmCloseMessage: PropTypes.string,
  footer: PropTypes.node,
  loading: PropTypes.bool,
  closable: PropTypes.bool,
  maskClosable: PropTypes.bool,
  zIndex: PropTypes.number,
  hasChanges: PropTypes.bool,
  disableEscapeKey: PropTypes.bool,
  className: PropTypes.string
};

export default BKModal;
